import { getSvgIcon } from '@helpers/icons';
import SvgLogo from '@img/logo-primary.svg';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from './Footer.styles';
const Footer = (props) => {
    return (React.createElement(S.Container, null,
        React.createElement(S.Inner, null,
            React.createElement(S.FooterTop, null,
                React.createElement(S.FooterTopLeft, null,
                    React.createElement(S.Logo, { href: "/", "aria-label": props.translations?.['global.navigation.home'] },
                        React.createElement(SvgLogo, null)),
                    props.description && (React.createElement(S.Description, { dangerouslySetInnerHTML: { __html: props.description } }))),
                props.footerLinks && (React.createElement(S.FooterTopRight, null, props.footerLinks.map((group, index) => (React.createElement(S.FooterLinksGroup, { key: `footerLinksGroup-${index}` },
                    group.title && React.createElement(S.FooterLinksGroupTitle, null, group.title),
                    React.createElement(S.FooterLinksGroupList, { "data-columns": group.links.length > 6 }, group.links.map((link, index) => (React.createElement(S.FooterLinkItem, { key: `footerLinkGroup-link-${index}` },
                        React.createElement("a", { href: link.url, target: link.target }, link.text))))))))))),
            React.createElement(S.FooterBottom, null,
                props.copyrightText && (React.createElement(S.CopyrightText, { dangerouslySetInnerHTML: { __html: props.copyrightText } })),
                React.createElement(S.SocialLinks, null, props.socialLinks &&
                    props.socialLinks.map((link) => (React.createElement(FocusRing, { key: `social-link-${link.text}`, focusRingClass: "focus-ring" },
                        React.createElement(S.SocialLink, { href: link.url, target: "_blank", title: link.text }, getSvgIcon(link.icon))))))))));
};
export default Footer;
